/* Shared campaign behaviour, scoped to the explicitly enrolled landing pages. */
;(function () {
  if (window.SchumannActiveOffer) return

  function live(config, now) {
    return Boolean(config && config.live && config.code && config.percent > 0 && config.percent <= 100 &&
      (!config.end || Number(config.end) * 1000 > (now == null ? Date.now() : now)))
  }

  function destination(href) {
    try {
      var parsed = new URL(href, location.origin)
      if (parsed.pathname.indexOf('/discount/') !== -1) return parsed.searchParams.get('redirect') || '/collections/all'
    } catch (_) {}
    return href
  }

  function link(href, config, active) {
    var base = destination(href)
    if (!active) return base
    var route = (config.root || '/').replace(/\/?$/, '/')
    return route + 'discount/' + encodeURIComponent(config.code) + '?redirect=' + encodeURIComponent(base)
  }

  function read(element) {
    var root = element.closest('[data-active-offer-page]')
    if (!root) return null
    if (root._activeOfferConfig) return root._activeOfferConfig
    var node = root.querySelector('[data-active-offer-config]')
    try {
      if (!node) return null
      var config = JSON.parse(node.textContent)
      if (node.hasAttribute('data-code')) config.code = node.dataset.code
      if (node.hasAttribute('data-root')) config.root = node.dataset.root
      return config
    } catch (_) { return null }
  }

  window.SchumannActiveOffer = {
    isLive: live,
    destination: destination,
    link: link,
    getCode: function (element) { var config = read(element); return live(config) ? config.code : '' },
  }

  function text(node, value) {
    if (node && node.textContent !== value) node.textContent = value
  }

  function boot(root) {
    if (root.dataset.aocReady) return
    var config = read(root)
    if (!config) return
    root._activeOfferConfig = config
    root.dataset.aocReady = 'true'
    var active = live(config)
    var replo = root.dataset.activeOfferPage === 'replo'

    function links() {
      root.querySelectorAll('a[href]').forEach(function (a) {
        var href = a.getAttribute('href') || ''
        if (!href || href.charAt(0) === '#') return
        var parsed
        try { parsed = new URL(href, location.origin) } catch (_) { return }
        if (parsed.origin !== location.origin && !/^https:\/\/(?:www\.)?theschumann\.com$/.test(parsed.origin)) return
        if (!a.hasAttribute('data-aoc-base-href') && !/\/(?:discount|products|cart)\/|\/collections\/all(?:[?#]|$)/.test(parsed.pathname)) return
        if (href !== a.dataset.aocManagedHref) a.dataset.aocBaseHref = destination(href)
        var next = link(a.dataset.aocBaseHref, config, active)
        a.dataset.aocManagedHref = next
        if (href !== next) a.setAttribute('href', next)
      })
      root.querySelectorAll('[data-device-url]').forEach(function (card) {
        var href = card.dataset.deviceUrl
        if (href !== card.dataset.aocManagedUrl) card.dataset.aocBaseUrl = destination(href)
        card.dataset.deviceUrl = link(card.dataset.aocBaseUrl, config, active)
        card.dataset.aocManagedUrl = card.dataset.deviceUrl
        if (!active && card.hasAttribute('data-aoc-device-price-regular')) card.dataset.devicePrice = card.dataset.aocDevicePriceRegular
      })
    }

    function discoverReplo() {
      if (!replo) return
      root.querySelectorAll('p').forEach(function (p) {
        if (p.textContent.trim() === 'Claim your exclusive offer!') {
          p.setAttribute('data-aoc-replo-summary', '')
        }
        if (!/^DAYS$/i.test(p.textContent.trim()) || p.closest('[data-aoc-clock]')) return
        var container = p.parentElement
        for (var depth = 0; container && depth < 9; depth++, container = container.parentElement) {
          var paragraphs = Array.from(container.querySelectorAll('p'))
          var labels = paragraphs.filter(function (n) { return /^(DAYS|HRS|MIN|SECS)$/i.test(n.textContent.trim()) })
          var numbers = Array.from(container.querySelectorAll('p, span')).filter(function (n) {
            return !n.childElementCount && /^\d{1,4}$/.test(n.textContent.trim())
          })
          if (labels.length === 4 && numbers.length === 4) {
            container.setAttribute('data-aoc-clock', '')
            numbers.forEach(function (n, i) { n.dataset.aocUnit = ['d', 'h', 'm', 's'][i] })
            break
          }
        }
      })
      root.querySelectorAll('[data-aoc-replo-summary]').forEach(function (p) {
        text(p, active ? config.percent + '% off with code ' + config.code : 'Explore the devices')
      })
    }

    function offers() {
      root.querySelectorAll('[data-aoc-only], [data-ska-offer], .pta-rail__badge, .pta-offer__pill, .pta-cta-micro, .pta-bar__offer').forEach(function (node) { node.hidden = !active })
      root.querySelectorAll('[data-aoc-regular-only]').forEach(function (node) { node.hidden = active })
      if (!active) {
        root.querySelectorAll('[data-aoc-price-output]').forEach(function (node) { text(node, node.dataset.aocRegular) })
        root.querySelectorAll('[data-aoc-savings-output]').forEach(function (node) { text(node, node.dataset.aocSavingsRegular) })
        root.querySelectorAll('[data-aoc-expired-label]').forEach(function (node) {
          var first = Array.from(node.childNodes).find(function (n) { return n.nodeType === 3 && n.textContent.trim() })
          if (first) first.textContent = node.dataset.aocExpiredLabel
        })
        root.dataset.code = ''
      }
      links()
      discoverReplo()
    }

    function clocks() {
      var remaining = Math.max(0, Math.floor((Number(config.end) * 1000 - Date.now()) / 1000))
      var values = { d: Math.floor(remaining / 86400), h: Math.floor(remaining % 86400 / 3600), m: Math.floor(remaining % 3600 / 60), s: remaining % 60 }
      var enabled = active && config.timer && config.end > 0 && remaining > 0
      root.querySelectorAll('[data-aoc-clock]').forEach(function (clock) {
        clock.hidden = !enabled
        if (!enabled) return
        clock.querySelectorAll('[data-u], [data-pet-cd], [data-aoc-unit]').forEach(function (node) {
          var key = node.dataset.u || node.dataset.petCd || node.dataset.aocUnit
          text(node, String(values[key]).padStart(2, '0'))
        })
        clock.querySelectorAll('[data-pta-left], [data-aoc-left]').forEach(function (node) {
          text(node, values.d + 'd ' + values.h + 'h ' + values.m + 'm ' + values.s + 's')
        })
      })
      root.querySelectorAll('[data-pet-bar-timer]').forEach(function (node) {
        node.hidden = !enabled
        if (enabled) text(node, ' · ends in ' + values.d + 'd ' + values.h + 'h ' + values.m + 'm')
      })
    }

    offers()
    clocks()

    // Opt-in for these campaign roots only. Existing global cart components and
    // the global storefront remain unchanged. Apply the campaign before replaying
    // the normal AddToCart click, whose existing drawer API owns the item/gift add.
    root.addEventListener('click', function (event) {
      var next = live(config)
      if (active !== next) { active = next; offers(); clocks() }
      var atc = event.target.closest('add-to-cart')
      if (!atc || !root.contains(atc) || atc.hasAttribute('sold-out')) return
      if (atc.dataset.aocReplay === 'true') { delete atc.dataset.aocReplay; return }
      var code = window.SchumannActiveOffer.getCode(atc)
      if (!code) return
      var button = event.target.closest('button')
      if (!button) return
      event.preventDefault()
      event.stopImmediatePropagation()
      if (atc.dataset.state === 'loading') return
      atc.dataset.state = 'loading'
      atc.setAttribute('aria-disabled', 'true')
      var error = atc.parentElement.querySelector('.aoc-cart-error')
      if (error) error.remove()
      var route = (config.root || '/').replace(/\/?$/, '/')
      var controller = new AbortController()
      var timeout = setTimeout(function () { controller.abort() }, 10000)
      fetch(route + 'cart/update.js', {
        method: 'POST',
        signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not apply the offer. Please try again.')
        return response.json()
      }).then(function () {
        clearTimeout(timeout)
        var drawer = document.querySelector('cart-drawer')
        if (drawer && drawer.requestRefresh) drawer.requestRefresh()
        atc.dataset.state = 'idle'
        atc.removeAttribute('aria-disabled')
        atc.dataset.aocReplay = 'true'
        button.click()
      }).catch(function () {
        clearTimeout(timeout)
        atc.dataset.state = 'error'
        atc.removeAttribute('aria-disabled')
        var message = document.createElement('p')
        message.className = 'aoc-cart-error'
        message.setAttribute('role', 'alert')
        message.textContent = 'Could not apply the offer. Please try again.'
        atc.after(message)
      })
    }, true)
    var timer
    if (config.end > 0) {
      timer = setInterval(function () {
        var next = live(config)
        if (active !== next) { active = next; offers() }
        clocks()
        if (!active) clearInterval(timer)
      }, 1000)
    }
    window.addEventListener('pageshow', function () {
      active = live(config)
      offers()
      clocks()
    })
    // Replo can hydrate its static export after load. Reconcile only this page's
    // commercial elements; retain its layout, images, editorial text and events.
    if (replo && window.MutationObserver) {
      var queued = false
      new MutationObserver(function () {
        if (queued) return
        queued = true
        queueMicrotask(function () { queued = false; offers(); clocks() })
      }).observe(root.querySelector('#replo-fullpage-element') || root, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] })
    }
  }

  function start() { document.querySelectorAll('[data-active-offer-page]').forEach(boot) }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
  else start()
  document.addEventListener('shopify:section:load', start)
})()
